import React from "react"
import { Link } from "react-router-dom"

import SourceListItem from "../../../sources/source-list/SourceListItem"
import SourceListItemShadow from "../../../sources/source-list/SourceListItemShadow"

const ViewFeedItemSource = ({ source, publisherDetails, isFetching }) => {
    let sourceComponent = null
    if (isFetching) {
        sourceComponent = <SourceListItemShadow />
    } else if (source) {
        sourceComponent = (
            <Link
                to={`/sources/${source.id}`}
                style={{ textDecoration: "none" }}
            >
                <SourceListItem {...source} />
            </Link>
        )
    } else if (publisherDetails) {
        sourceComponent = <SourceListItem {...publisherDetails} />
    } else {
        sourceComponent = <p>No source.</p>
    }
    return (
        <div className="widget">
            <h3 className="widget-header">
                <span className="icon icon-source" />
                {source ? "Source" : "Publisher"}
            </h3>
            <div className="widget-content list-group items-list">
                {sourceComponent}
            </div>
        </div>
    )
}

export default ViewFeedItemSource
